import { CommonModule } from "@angular/common";

import { NgModule, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { LoadingBarModule } from "@ngx-loading-bar/core";

import { TranslateModule } from "@ngx-translate/core";

import { LogoComponent } from "@hermes/aphrodite-logo";
import {
    svgBackArrow,
    svgBars,
    svgCross,
    svgFilledCart,
    SvgIconComponent,
    svgPerson,
    svgPersonWithDot,
    SvgRegistryService,
    svgSearch,
} from "@hermes/aphrodite-svg";
import { MediaPictureCtaComponent } from "@hermes/domains-edito-fragments-media-cta";
import { BackToHomeButtonModule } from "@hermes/hermes-web-fragments-back-to-home-button";
import { SeoLinksComponent } from "@hermes/hermes-web-fragments-seo-links";
import { BannersModule } from "@hermes/domains-shell-fragments-banners";
import {
    AsMenuEntryItemWithEditoPipe,
    MenuAnalyticsService,
    MenuUtilsService,
} from "@hermes/domains-shell-fragments-menu-shared";
import { MenuStateModule } from "@hermes/domains-shell-states-menu-state";
import { TrayStateModule } from "@hermes/hermes-web-states-tray-state";
import { UserStateModule } from "@hermes/hermes-web-states-user-state";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";
import { RouterServiceModule } from "@hermes/utils-generic-services-router";

import { BackButtonCheckoutComponent } from "./components/back-button-checkout/back-button-checkout.component";
import { HeaderComponent } from "./components/header/header.component";
import { HeaderBarComponent } from "./components/header-bar/header-bar.component";
import { HeaderLightComponent } from "./components/header-light/header-light.component";
import { HeaderLinksComponent } from "./components/header-links/header-links.component";
import { HeaderSearchBarComponent } from "./components/header-search-bar/header-search-bar.component";
import { HeaderSearchSuggestionsComponent } from "./components/header-search-suggestions/header-search-suggestions.component";
import { MenuBarEditoComponent } from "./components/menu-bar/menu-bar-edito/menu-bar-edito.component";
import { MenuBarLinkComponent } from "./components/menu-bar/menu-bar-link/menu-bar-link.component";
import { MenuBarComponent } from "./components/menu-bar/menu-bar.component";
import { MenuParentCategoryComponent } from "./components/menu-bar/parent-category/menu-parent-category.component";
import { MenuSubCategoryComponent } from "./components/menu-bar/sub-category/menu-sub-category.component";
import { RedrawDirective } from "./directives/redraw/redraw.directive";
import { CartLabelPipe } from "./pipes/cart-label.pipe";
import { StrongPipe } from "./pipes/strong.pipe";
import { SuggestionItemPipe } from "./pipes/suggestion-item.pipe";
import { HeaderSearchService } from "./services/header-search.service";
@NgModule({
    imports: [
        BannersModule,
        CommonModule,
        SrOnlyNoSnippetDirective,
        FormsModule,
        LoadingBarModule,
        SeoLinksComponent,
        LogoComponent,
        MenuStateModule,
        ReactiveFormsModule,
        RouterServiceModule,
        SvgIconComponent,
        TranslateModule,
        TrayStateModule,
        UserStateModule,
        BackToHomeButtonModule,
        AsMenuEntryItemWithEditoPipe,
        MediaPictureCtaComponent,
        BackButtonCheckoutComponent,
        CartLabelPipe,
        HeaderBarComponent,
        HeaderComponent,
        HeaderLightComponent,
        HeaderLinksComponent,
        HeaderSearchBarComponent,
        HeaderSearchSuggestionsComponent,
        SuggestionItemPipe,
        StrongPipe,
        RedrawDirective,
        MenuBarComponent,
        MenuParentCategoryComponent,
        MenuSubCategoryComponent,
        MenuBarEditoComponent,
        MenuBarLinkComponent,
    ],
    providers: [HeaderSearchService, MenuAnalyticsService, MenuUtilsService],
    exports: [HeaderComponent, HeaderLightComponent],
})
export class HeaderModule {
    constructor() {
        const svgRegistryService = inject(SvgRegistryService);

        svgRegistryService.registerSvgs([
            svgBars,
            svgCross,
            svgSearch,
            svgBackArrow,
            svgPerson,
            svgPersonWithDot,
            svgFilledCart,
        ]);
    }
}
